const DOCUMENT_POSITION_FOLLOWING = 4
const DOCUMENT_POSITION_CONTAINED_BY = 16

export function precedes(node, other) {
  if (!node || !other || node === other) return false

  const position = node.compareDocumentPosition(other)

  return (
    (position & DOCUMENT_POSITION_FOLLOWING) !== 0 &&
    (position & DOCUMENT_POSITION_CONTAINED_BY) === 0
  )
}

export function scrollCorrection(before, after) {
  const shift = after - before

  return Math.abs(shift) < 1 ? 0 : shift
}

export async function keepViewportPosition(
  element,
  change,
  win = typeof window === 'undefined' ? null : window
) {
  const before = element.getBoundingClientRect().top
  await change()
  const shift = scrollCorrection(before, element.getBoundingClientRect().top)

  if (shift && win) win.scrollBy(0, shift)

  return shift
}
